import React from 'react';
import styles from './CardQualityBadge.module.css';

export function cardQualityStatus(product) {
    if (['confirmed', 'unverified', 'unfilled'].includes(product?.card_status)) return product.card_status;
    // Старый verified означает наличие данных поставщика, а не полноту карточки.
    const category = product?.annotation_category?.name_ru || product?.categories_ru?.length || product?.categories?.length;
    const values = product?.parameters?.some(p => !['has_pdf_link', 'has_image_link'].includes(p.code) && (p.raw || p.value_ru));
    return category && !product?.category_proposed && values ? 'unverified' : 'unfilled';
}

export default function CardQualityBadge({product}) {
    const status = cardQualityStatus(product);
    return <span className={`${styles.badge} ${styles[status]}`}>{({confirmed: 'Подтверждена', unverified: 'Не проверена', unfilled: 'Не заполнена'})[status]}</span>;
}
